import { useCallback } from 'react';
import Decimal from 'decimal.js';

import useSelectedFlightOptions from '@/hooks/useSelectedFlightOptions';

const sum =
  (key) =>
  (...offers) =>
    offers.reduce((result, offer) => {
      if (!offer) return 0;
      const d = Decimal.add(result, offer.charges[key].amount);

      return d.toNumber();
    }, 0);

const useGetOfferCharges = ({
  selectedOutboundFlightOption,
  selectedInboundFlightOption,
} = {}) => {
  const { selectedOutboundOption, selectedInboundOption } =
    useSelectedFlightOptions();

  const outboundOption = selectedOutboundFlightOption || selectedOutboundOption;
  const inboundOption = selectedInboundFlightOption || selectedInboundOption;

  const getOfferCharge = useCallback(
    (offer) =>
      ['total', 'perTraveller', 'perAdult'].reduce(
        (obj, key) => ({
          ...obj,
          [key]: {
            amount: sum(key)(outboundOption, inboundOption, offer),
            currency: offer.charges[key].currency,
          },
        }),
        {},
      ),
    [inboundOption, outboundOption],
  );

  return getOfferCharge;
};

export const getOfferCharges = ({
  offer,
  selectedInboundOption,
  selectedOutboundOption,
}) =>
  ['total', 'perTraveller', 'perAdult'].reduce(
    (obj, key) => ({
      ...obj,
      [key]: {
        amount: sum(key)(selectedOutboundOption, selectedInboundOption, offer),
        currency: offer.charges[key].currency,
      },
    }),
    {},
  );

export default useGetOfferCharges;
